/**
 * 退改计算器结果详情页面
 */
import Routes from 'Routes';
import FeeQueryContainer from './components/FeeQueryContainer';
export default store => ({
  path: Routes.ticket.child.feeQuery.key,
  component: FeeQueryContainer,
  getChildRoutes(partialNextState, cb) {
    require.ensure(
      [],
      require => {
        cb(null, [
          require('./routes/login').default(store),
          require('./routes/list').default(store),
          require('./routes/detail').default(store),
        ]);
      },
      'feeQueryChilds'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/feeQuery/index.js